var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "new-item" }, [
    _c("div", { staticClass: "new-item-meta" }, [
      _vm.ribbonText
        ? _c("span", { staticClass: "new-item-version" }, [
            _vm._v(_vm._s(_vm.ribbonText)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.date
        ? _c("span", { staticClass: "new-item-date" }, [
            _c("span", { staticClass: "new-item-date__icon" }, [_vm._v("📅")]),
            _vm._v("\n            " + _vm._s(_vm.date) + "\n        "),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "news-content" }, [
      _c("div", { staticClass: "news-text" }, [
        _c("h3", { staticClass: "new-item-title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _vm._v(" "),
        _vm.ticket
          ? _c("div", { staticClass: "new-item-ticket" }, [
              _vm._v(_vm._s(_vm.ticket)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "new-item-description" }, [
          _c("div", {
            staticClass: "new-item-description__body",
            domProps: { innerHTML: _vm._s(_vm.description) },
          }),
          _vm._v(" "),
          _vm.newsLink
            ? _c(
                "button",
                { staticClass: "link-btn", on: { click: _vm.clickLine } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.newsLink) +
                      "\n                    "
                  ),
                  _c("span", { staticClass: "link-btn__arrow" }, [_vm._v("↗")]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.mediaUrl
        ? _c("div", { staticClass: "news-media" }, [
            _vm.isImage
              ? _c("img", {
                  staticClass: "media-content",
                  attrs: {
                    src: _vm.mediaUrl,
                    alt: _vm.$t("message.newsMediaAlt"),
                  },
                })
              : _vm.isVideo
              ? _c("video", {
                  staticClass: "media-content",
                  attrs: {
                    src: _vm.mediaUrl,
                    autoplay: "",
                    muted: "",
                    loop: "",
                  },
                  domProps: { muted: true },
                })
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }